import styled from 'styled-components'
import {MobileCalendar} from '../../../../../../../components/calendar-events/mobile/MobileCalendar'

export const StyledMobileCalendar = styled(MobileCalendar)`
    div {
        overflow-y: hidden;
    }
`
